import { render, staticRenderFns } from "./orders.pug?vue&type=template&id=024ba2da&lang=pug&"
import script from "./orders.ts?vue&type=script&lang=ts&"
export * from "./orders.ts?vue&type=script&lang=ts&"
import style0 from "./orders.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports